export default (callback) => {
    if (typeof callback !== 'function') {
        throw "Expected a callable on starter.js";
    }

    window.addEventListener('DOMContentLoaded', () => {
        const $style = document.getElementById('main-css');

        if ($style) {
            if ($style.isLoaded) {
                callback();
            } else {
                $style.addEventListener('load', (event) => {
                    callback();
                });
            }
        } else {
            console.warn('The "main-css" stylesheet not found');
        }
    });
};
